// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-page-templates-basic-page-js": () => import("./../../../src/components/page-templates/basic-page.js" /* webpackChunkName: "component---src-components-page-templates-basic-page-js" */)
}

